import type { MonthlySalesDetailed } from '../../data/fetchers';
import { fmtAmount } from '../../lib/format';

export function MonthlyPromotions({
  promotions,
  monthLabel,
  scopeLabel,
}: {
  promotions: MonthlySalesDetailed['promotions'];
  monthLabel: string;
  scopeLabel: string;
}) {
  const sorted = [...promotions].sort(
    (a, b) =>
      b.discountAmount - a.discountAmount ||
      a.promotionId.localeCompare(b.promotionId),
  );
  const total = sorted.reduce((sum, row) => sum + row.discountAmount, 0);
  return (
    <section
      aria-labelledby="monthly-promotions-heading"
      className="border-t border-line pt-5"
    >
      <h3 id="monthly-promotions-heading" className="text-h3 font-semibold">
        การใช้โปรโมชั่น
      </h3>
      <p className="mt-1 text-sm-label text-ink-3">
        {monthLabel} · {scopeLabel} · เรียงตามส่วนลดรวม
      </p>
      {sorted.length === 0 ? (
        <p className="py-6 text-body text-ink-3">
          ไม่มีการใช้โปรโมชั่นที่บันทึกแยกไว้ในเดือนนี้
        </p>
      ) : (
        <>
          <table
            className="monthly-promotion-table mt-3 w-full text-body"
            aria-label={`การใช้โปรโมชั่น ${monthLabel}`}
          >
            <thead>
              <tr>
                <th scope="col">โปรโมชั่น</th>
                <th scope="col" className="monthly-promo-desktop text-right">
                  บิลที่ใช้โปร
                </th>
                <th scope="col" className="monthly-promo-desktop text-right">
                  ของแถม (หน่วย)
                </th>
                <th scope="col" className="text-right">
                  ส่วนลดรวม (บาท)
                </th>
              </tr>
            </thead>
            <tbody>
              {sorted.map((row) => (
                <tr key={row.promotionId}>
                  <th scope="row" className="monthly-promo-name">
                    {row.promotionName}
                    <span className="monthly-promo-mobile mt-1 text-sm-label text-ink-3">
                      ใช้ใน {row.receiptCount.toLocaleString()} บิล
                      {row.freeQuantity > 0 ? (
                        <>
                          <br />
                          ของแถม {row.freeQuantity.toLocaleString()} หน่วย
                        </>
                      ) : (
                        ' · ไม่มีของแถม'
                      )}
                    </span>
                  </th>
                  <td className="monthly-promo-desktop num text-right">
                    {row.receiptCount.toLocaleString()}
                  </td>
                  <td className="monthly-promo-desktop num text-right">
                    {row.freeQuantity > 0
                      ? row.freeQuantity.toLocaleString()
                      : '—'}
                  </td>
                  <td className="num text-right">
                    {fmtAmount(row.discountAmount)}
                  </td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr>
                <th scope="row">ส่วนลดจากโปรโมชั่นรวม</th>
                <td colSpan={2} className="monthly-promo-desktop" />
                <td className="num text-right">{fmtAmount(total)}</td>
              </tr>
            </tfoot>
          </table>
          <div className="mt-3 space-y-1 text-sm-label text-ink-3">
            <p>บิลเดียวใช้ได้หลายโปร จำนวนบิลแต่ละแถวจึงอาจซ้ำกัน</p>
            <p>
              ส่วนลดรวมอยู่ในยอดขายสุทธิแล้ว ไม่ต้องหักซ้ำ · ของแถมนับเป็นหน่วย
              ไม่ใช่ต้นทุนของแถม
            </p>
          </div>
        </>
      )}
    </section>
  );
}
